import React from 'react';
import { IQuickFilterContext } from 'framework/IQuickFilterContext';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { ISettlementProposal, SettlementProposalExportProp } from 'gen/ApiClient';
import { SelectableColumn } from '../SelectableColumn';
import { QuickFilter } from '../SettlementProposalsCard';

interface IViewContext extends ITableViewContext<SelectableColumn, ISettlementProposal>, IQuickFilterContext<QuickFilter> {
	exportRecord: Record<SettlementProposalExportProp, string>;
}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
